<template>
  <v-row v-loading="!dataLoaded">
    <v-col cols="12" class="pt-0">
      <PageTitle title="Назначение конкурса"/>
    </v-col>

    <v-col cols="12" class="py-0">
      <v-btn
        small
        outlined
        rounded
        color="primary"
        class="white--text px-4 mr-2"
        @click="$router.push({name: 'contestPage'})"
      >
        <v-icon left small>mdi-chevron-left</v-icon>
        Назад
      </v-btn>
    </v-col>

    <v-col cols="12">
      <PageTable
        :table-loading="tableLoading"
        :table-headers="tableHeaders"
        filter
        :table-items="applications.list"
        table-height="284"
      >
      </PageTable>
    </v-col>

  </v-row>
</template>

<script>
import { applicationApi } from '@/api'
import {ApplicationParent} from '@/models'
import PageTable from '@/components/ui/Table'
import PageTitle from '@/components/ui/Title'
import {mapGetters, mapState} from "vuex";

export default {
  name: 'RatingLine',

  components: {
    PageTable,
    PageTitle
  },

  data: () => ({
    applications: new ApplicationParent(),
    tableLoading: false
  }),

  computed: {
    ...mapState('system', ['dataLoaded']),
    ...mapGetters('user', ['isCurator', 'isAdmin']),

    checkRoles() {
      return this.isCurator || this.isAdmin
    },

    tableHeaders() {
      return [
        { text: 'Номер', value: 'id', sortable: false, align: 'start' },
        { text: 'Статус', value: 'applicationStatus.name', sortable: false, align: 'start' },
        { text: 'Тип заявления', value: 'applicationType.name', sortable: false, align: 'start' },
        { text: 'Специальность', value: 'specialityTo.name', sortable: false, align: 'start' },
        { text: 'Курс', value: 'courseNumberTo.name', sortable: false, align: 'start' },
        { text: 'Тип обучения', value: 'paidFormTo.name', sortable: false, align: 'start' },
        { text: 'Дата отправки', value: 'sendDateTime', sortable: false, align: 'start' },
        { text: 'ФИО', value: 'fullName', sortable: false, align: 'start' },
      ]
    }
  },

  methods: {
    async getGroups() {
      try {
        this.tableLoading = true
        const data = await applicationApi.findAllByVacancy(this.$route.params.id)
        data.length && this.applications.build(data)
        console.log(data)
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.tableLoading = false
      }
    },
  },

  watch: {
    dataLoaded: {
      immediate: true,
      async handler(value) {
        if (value) {
          if (!this.checkRoles) await this.$router.push('/')
          await this.getGroups()
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
